import React from "react";
import { ComplianceTrainingList } from "./ComplianceTrainingList";
import { BookOpenCheck } from "lucide-react";

export const SupportTrainingIndex: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-5xl mx-auto px-6 py-10 space-y-6">
        <div className="flex items-start gap-3">
          <div className="bg-blue-100 text-blue-600 p-2 rounded-lg">
            <BookOpenCheck className="h-6 w-6" />
          </div>
          <div>
            <h1 className="text-2xl font-bold text-gray-900">Training</h1>
            <p className="text-sm text-gray-600 mt-1">Complete trainings to stay compliant.</p>
          </div>
        </div>

        <ComplianceTrainingList mode="optional" />
      </div>
    </div>
  );
};
